import './contact-in-process.component.ajscss';

import { IEpticaDeprecatedService } from '@agent/core/channel-digit/mail/eptica/eptica-deprecated.service';
import { IAppointmentDeprecatedService } from '@agent/core/contact/appointment-deprecated.service';
import { IContactHistoryService } from '@agent/core/contact/history/contact-history.service';
import { REFRESH_HISTO_INTERACTIONS, REFRESH_INPROCESS_INTERACTIONS } from '@agent/core/contact/history/models/history-models';
import { ModalService } from '@commons/core/ui/modal/modal.service';
import { IModalEvent } from '@commons/core/ui/modal/models/modal-event';
import { ITimelineEntry } from '@commons/history/timeline//models/timeline-entry';
import { Appointment, IAppointment } from '@commons/models/appointment';
import { hasChange } from '@commons/util/helper/helper';
import { ng1Destroy } from '@commons/util/utilities/rx';
import { IChangesObject, IComponentController, IComponentOptions, ILogService } from 'angular';
import { i18n } from 'i18next';
import {
  delay,
  distinctUntilChanged,
  EMPTY,
  filter,
  merge,
  Observable,
  Subject,
  Subscription,
  switchMap,
  takeUntil,
  tap,
  toArray,
} from 'rxjs';

import {
  Booking,
  BookingFacade,
  ChannelType,
  Customer,
  isNotNullOrUndefined,
  LoaderDeprecatedService,
  MessagingService,
  Option,
} from '@contact/upgrade';

import templateUrl from './contact-in-process.component.ajs.html';

const MODULE_NAME = 'contactInProcessView';
const NB_INPROCESS_TO_LOAD: number = 50;

class ContactInProcessCtrl implements IComponentController {
  public name = MODULE_NAME;

  contact$ = this.contactFacade.selected$;
  customer$ = this.contactFacade.selectedCustomer$;

  contact: Booking | undefined;
  customer: Customer | undefined;
  responseId: string | undefined;
  currentInteractionId: string | undefined;

  firstCall = true;
  messageString;
  message: string;

  defaultViewInteractions: number;
  histoViewCompany: boolean | undefined;
  activeCustomer: boolean;
  activeCompany: boolean;
  contactCompanyName: string = '';

  inProgressContactList: ITimelineEntry[];

  private modalSubscription = Subscription.EMPTY;
  private cancel$ = new Subject<boolean>();

  constructor(
    private readonly $log: ILogService,
    private readonly $i18next: i18n,
    private readonly agentHistory: IContactHistoryService,
    private readonly $uibModal: any,
    private readonly appointmentDeprecatedService: IAppointmentDeprecatedService,
    private readonly epticaDeprecatedService: IEpticaDeprecatedService,
    private readonly messaging: MessagingService,
    private readonly modalService: ModalService,
    private readonly loaderDeprecatedService: LoaderDeprecatedService,
    private readonly contactFacade: BookingFacade
  ) {}

  $onInit(): void {
    if (this.histoViewCompany) {
      if ((this.defaultViewInteractions === 1 && this.firstCall) || !this.activeCompany) {
        this.firstCall = false;
      }
      this.showTimelineInProcess();
    }
    this.contact$.pipe(ng1Destroy(this)).subscribe(contact => {
      this.contact = contact;
      this.responseId = contact && contact.responseId;
      this.currentInteractionId = contact && contact.currentInteractionId;
    });
    this.customer$.pipe(ng1Destroy(this)).subscribe(customer => (this.customer = customer));

    // auto refresh
    this.contact$
      .pipe(
        isNotNullOrUndefined(),
        distinctUntilChanged(
          (customerId1, customerId2) => customerId1 === customerId2,
          ({ customerId }) => customerId
        ),
        tap(() => {
          this.inProgressContactList = [];
        }),
        switchMap(() =>
          merge(
            // refresh init
            this.refreshTimelineInProcess(0),
            // refresh the appointment part if new one has been created
            this.messaging
              .forLocal()
              .listen$(REFRESH_INPROCESS_INTERACTIONS)
              .pipe(
                switchMap(() =>
                  this.loaderDeprecatedService.process(this.refreshTimelineInProcess(0), 'Area-InProcess-List', 'Area-historyContact-List')
                )
              )
          )
        ),
        ng1Destroy(this)
      )
      .subscribe();
  }

  $onDestroy(): void {
    this.modalSubscription.unsubscribe();
    this.cancel$.complete();
  }

  $onChanges(changesObj: { [property: string]: IChangesObject }) {
    // changed
    if (hasChange(changesObj['contactCompanyName'])) {
      this.contactCompanyName = changesObj['contactCompanyName'].currentValue;
    }
    if (hasChange(changesObj['activeCompany'])) {
      this.showTimelineInProcess();
    }
  }

  /**
   * Remove the selected appointment
   */
  removeAppointment(_appointment: ITimelineEntry) {
    this.$log.info('[ContactViewInProcessCtrl] removeAppointment row: [' + JSON.stringify(_appointment) + ']');
    let tmp: IAppointment = new Appointment();
    tmp.idContact = _appointment.id;
    // the only important thing is the id of the appointment (witch is the contact of the campaign)
    this.appointmentDeprecatedService.deleteAppointment(tmp).then(
      () => this.$log.info('[ContactViewInProcessCtrl] removeAppointment success'),
      () => this.$log.info('[ContactViewInProcessCtrl] removeAppointment error')
    );
  }

  /**
   * Popin for validate an appointment deletion
   */
  openDeleteAppointmentConfirmation(_appointment: ITimelineEntry) {
    this.$uibModal
      .open({
        component: 'contactConfirmAppointmentDeletion',
        keyboard: false,
        ariaLabelledBy: 'modal-header',
        ariaDescribedBy: 'modal-body',
      })
      .result.then(() => this.removeAppointment(_appointment));
  }

  /**
   * Called when the user selects an element in the in process list
   */
  openPopin(element: ITimelineEntry) {
    this.$log.debug('[ContactViewInProcessCtrl] received [' + JSON.stringify(element) + ']');
    this.modalSubscription.unsubscribe();
    this.modalSubscription = this.modalService
      .open({
        keyboard: false,
        backdrop: false,
        fullscreen: true,
        ctrlKeyboard: true,
        component: 'contactContactViewHistoPopin',
        title:
          this.$i18next.t('agent:contact.info.popin.title') +
          ` ${this.customer && this.customer.lastname} ${this.customer && this.customer.firstname}`,
        resolve: {
          contactCalling: () => Option.of(this.contact),
          selectContactEntry: () => element,
        },
      })
      .pipe(
        filter((evtModal: IModalEvent) => evtModal.type === 'close' || evtModal.type === 'reduce'),
        tap(() => this.refreshTimelineHisto()),
        switchMap(() =>
          this.loaderDeprecatedService.process(this.refreshTimelineInProcess(0), 'Area-InProcess-List', 'Area-historyContact-List')
        ),
        ng1Destroy(this)
      )
      .subscribe();
  }

  linkTimeline(elements: ITimelineEntry[]) {
    const contact = this.contact;
    if (!contact) {
      return;
    }
    this.$log.info('[ContactViewInProcessCtrl] linked [' + JSON.stringify(elements) + ']');
    // active loader
    this.loaderDeprecatedService.active('Area-InProcess-List', 'Area-historyContact-List');
    // list to link
    let link$: Observable<any>[] = elements.map(time =>
      this.epticaDeprecatedService.safeLinkRequest(
        parseInt((time.contactEntry && time.contactEntry.epticaRequestId) || '', 10),
        contact.connectionId
      )
    );
    // launch async
    merge(...link$)
      .pipe(
        // Here we give some time (1s) to ES to update before refreshing History Timeline
        delay(1000),
        toArray(),
        switchMap(ids => {
          // partition request error/success
          let timelineError = elements.filter(entry => !ids.some(id => !!entry.contactEntry && id === entry.contactEntry.epticaRequestId));
          let timelineSuccess = elements.filter(entry => ids.some(id => !!entry.contactEntry && id === entry.contactEntry.epticaRequestId));
          // refresh zone histo
          this.refreshTimelineHisto(timelineSuccess);
          // refresh zone in process
          return this.refreshTimelineInProcess(0, timelineError);
        }),
        ng1Destroy(this)
      )
      .subscribe({
        complete: () => {
          this.$log.info('[ContactViewInProcessCtrl] linked reload in process interaction');
          // dispose loader
          this.loaderDeprecatedService.dispose('Area-InProcess-List', 'Area-historyContact-List');
        },
      });
  }

  public showTimelineInProcess(): void {
    this.inProgressContactList = [];
    this.getNextInProcess(0);
  }

  private getNextInProcess(_from: number): void {
    if (!this.contact) {
      return;
    }
    let inProgressContactList: ITimelineEntry[] = [];
    if (_from >= this.inProgressContactList.length) {
      let param;
      param = { from: _from, size: NB_INPROCESS_TO_LOAD };
      if (this.activeCompany) {
        param.companyName = this.contactCompanyName;
      } else {
        param.contact = this.contact;
      }
      this.agentHistory
        .findInProcess(param)
        .pipe(ng1Destroy(this))
        .subscribe(result => {
          let myVals = {};
          inProgressContactList = inProgressContactList.concat(result.timeline).filter(entry => {
            // uniq filter
            if (myVals[entry.id]) {
              return false;
            }
            myVals[entry.id] = true;
            return true;
          });
          this.inProgressContactList = inProgressContactList.filter(
            ipcl => ipcl.canalName !== ChannelType.MAIL || ipcl.isEpticaSynchronized
          );
        });
    }
  }

  public refreshTimelineInProcess(_from: number, entriesInProcessToMatch: ITimelineEntry[] = []): Observable<any> {
    const contact = this.contact;
    if (!contact) {
      return EMPTY;
    }
    this.cancel$.next(true);

    let inProgressContactList: ITimelineEntry[] = [];
    if (entriesInProcessToMatch.length > 0) {
      // Only when entriesInProcessToMatch is not empty(requests from linkTimeline) should inProgressContactList be pre-filtered
      let entriesInProcessToMatchIds = entriesInProcessToMatch.map(({ id }) => id);
      inProgressContactList = inProgressContactList.filter(({ id }) => entriesInProcessToMatchIds.indexOf(id) < 0);
    }

    this.inProgressContactList = this.inProgressContactList.filter((entry: ITimelineEntry) => !entry.appointment);
    let param;
    param = { entityToMatch: entriesInProcessToMatch, from: _from, size: NB_INPROCESS_TO_LOAD };
    if (this.activeCompany) {
      param.companyName = this.contactCompanyName;
    } else {
      param.contact = contact;
    }
    return this.agentHistory.findInProcess(param).pipe(
      tap(_result => {
        let myVals = {};
        inProgressContactList = inProgressContactList.concat(_result.timeline).filter(entry => {
          // uniq filter
          if (myVals[entry.id]) {
            return false;
          }
          myVals[entry.id] = true;
          return true;
        });
        this.inProgressContactList = inProgressContactList.filter(ipcl => ipcl.canalName !== ChannelType.MAIL || ipcl.isEpticaSynchronized);
      }),
      takeUntil(this.cancel$)
    );
  }

  private refreshTimelineHisto(entriesToMatch: ITimelineEntry[] = []): void {
    this.messaging.forLocal().publish(REFRESH_HISTO_INTERACTIONS, { timeline: entriesToMatch });
  }
}

export class ContactInProcess implements IComponentOptions {
  templateUrl = templateUrl;
  bindings = {
    defaultViewInteractions: '<',
    histoViewCompany: '<',
    contactCompanyName: '<',
    activeCompany: '<',
  };
  controller = [
    '$log',
    '$i18next',
    'agentHistory',
    '$uibModal',
    'appointmentDeprecatedService',
    'epticaDeprecatedService',
    'messaging',
    'modalService',
    'loaderDeprecatedService',
    'contactFacade',
    ContactInProcessCtrl,
  ];
}

export default MODULE_NAME;
